import {StudiesNames} from './studies-names';
import {Routes} from '@angular/router';

export class StudyRouteDefinition {
    constructor(public readonly studyId: StudiesNames,
                public routes: Routes,
                public readonly path: string = studyId) {
    }
}
